<footer class="footer" >
  <div fxLayout="row" fxLayoutAlign="center center" class="text-center">
    <h4 class="site-by">
      Site by <a href="mailto:ryan.david.pascal@gmail.com">Ryan Pascal</a>
    </h4>
  </div>
</footer>
